import axios from "axios";
import config from "../config";
import type { ApiSuccess } from "./api_helper";

// Mesmo padrão dos outros helpers: base vem do config (axios já tem baseURL).
const apiBase = config.api.API_URL;

/** Prévia do convite de owner (LAC-074) — rota pública. */
export type OwnerInvitePreview = {
  email: string;
  tenant_name: string;
  expires_at: string | null;
};

export type OwnerInviteAcceptResult = {
  access_token: string;
  token_type: string;
  expires_in: number;
  user: {
    id: number;
    name: string;
    email: string;
  };
};

export const validateOwnerInvite = (
  token: string
): Promise<ApiSuccess<OwnerInvitePreview>> =>
  axios.get(apiBase + "/owner-invite/validate", { params: { token } });

export const acceptOwnerInvite = (payload: {
  token: string;
  password: string;
  password_confirmation: string;
}): Promise<ApiSuccess<OwnerInviteAcceptResult>> =>
  axios.post(apiBase + "/owner-invite/accept", payload);
